import { useContext, useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Avatar, Box, Divider, Drawer, IconButton, Typography } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useAuth from '../../hooks/useAuth';
import UserIcon from '../../icons/User';
import Logo from './Logo';
import NavSection from './NavSection';
import Scrollbar from './Scrollbar';
import AuthContext from '../../contexts/JWTContext';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ShoppingCartIcon from '../../icons/ShoppingCart';
import CalendarIcon from '../../icons/Calendar';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
// import HowToRegIcon from '@material-ui/icons/HowToReg';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
// import AssistantIcon from '@material-ui/icons/Assistant';
// import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import ChatAltIcon from '../../icons/ChatAlt';
// import CachedIcon from '@material-ui/icons/Cached';
// import SwapHorizontalCircleIcon from '@material-ui/icons/SwapHorizontalCircle';
import { ChatContext } from '../../contexts/ChatContext';
import BallotIcon from '@material-ui/icons/Ballot';
import { AssignmentTurnedIn, KeyboardArrowLeft, KeyboardArrowRight, Search } from '@material-ui/icons';
// import ContactPhoneIcon from '@material-ui/icons/ContactPhone';

const DashboardSidebar = (props) => {
  const { onMobileClose, openMobile, toggle, collapsed } = props;
  const location = useLocation();
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const { user } = useAuth();
  const { unReadedMessageCount } = useContext(ChatContext);

  const mainSections = [
    {
      items: [
        {
          title: 'Anasayfa',
          path: '/',
          icon: <DashboardIcon fontSize={collapsed ? 'large' : 'small'} />
        },
      ]
    },
    {
      divider: true,
      title: 'MÜŞTERİ',
      items: [

        {
          title: 'İhalelerim',
          path: '/orders',
          icon: <CalendarIcon fontSize={collapsed ? 'large' : 'small'} />
        },
      ]
    },
    {
      divider: true,
      title: 'Ön Talep',
      items: [
        {
          title: 'Ön Taleplerim',
          path: '/predemands',
          icon: <AssignmentTurnedIn fontSize={collapsed ? 'large' : 'small'} />
        },
      ]
    },
    {
      divider: true,
      title: 'TEDARİKÇİ',
      items: [
        {
          title: 'Tekliflerim',
          path: '/bids',
          icon: <HourglassFullIcon fontSize={collapsed ? 'large' : 'small'} />
        },
        {
          title: 'İhaleler',
          path: '/deals',
          icon: <StarHalfIcon fontSize={collapsed ? 'large' : 'small'} />
        },
      ],
    },
    {
      divider: true,
      title: 'GENEL',
      items: [
        {
          title: 'Favori Firmalarım',
          path: '/account?tab=blocked',
          icon: <ThumbUpIcon fontSize={collapsed ? 'large' : 'small'} />,
        },
        {
          title: 'Tedarikçi Ara',
          path: '/account?tab=blocked&orderTab=searchForSupplier',
          icon: <Search fontSize={collapsed ? 'large' : 'small'} />,
        },
        {
          title: 'Faaliyet Alanlarım',
          path: '/account?tab=services',
          icon: <BallotIcon fontSize={collapsed ? 'large' : 'small'} />,
        },
      ],
    },
    {
      divider: true,
      title: 'GENEL',
      items: [
        {
          title: 'Hesabım',
          path: '/account',
          icon: <UserIcon fontSize={collapsed ? 'large' : 'small'} />,
        },
        {
          title: 'Mesajlarım',
          path: '/chat',
          icon: <ChatAltIcon fontSize={collapsed ? 'large' : 'small'} />,
          badgeCount: unReadedMessageCount
        },
      ],
    },
    {
      title: 'DESTEK',
      items: [
        {
          title: 'Yardım Merkezi',
          path: '/help',
          icon: <LiveHelpIcon fontSize={collapsed ? 'large' : 'small'} />
        },
        // {
        //   title: 'Bize Ulaşın',
        //   path: '/contactus',
        //   icon: <ContactPhoneIcon fontSize={collapsed ? 'large' : 'small'} />
        // },
        {
          title: 'Çıkış Yap',
          path: '/LogOut',
          icon: <MeetingRoomIcon fontSize={collapsed ? 'large' : 'small'} />
        },
      ],
    },
  ];

  if (user?.permissions?.hasCreateAndDeleteBid === true) {
    mainSections[1].items.unshift({
      title: 'İhale / Talep Aç',
      path: '/orders/create',
      icon: <ShoppingCartIcon fontSize={collapsed ? 'large' : 'small'} />,
    });
  }

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <AuthContext.Consumer>
      {
        () => (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%'
            }}
            className="tp-sidebar"
          >
            <Scrollbar options={{ suppressScrollX: true }}>
              <Box
                sx={{
                  display: {
                    lg: 'flex',
                    xs: 'none'
                  },
                  justifyContent: 'end',
                }}
              >
                <IconButton onClick={toggle}>
                  {
                    collapsed ? <KeyboardArrowRight htmlColor="#fff" /> : <KeyboardArrowLeft htmlColor="#fff" />
                  }
                </IconButton>
              </Box>
              <Box
                sx={{
                  display: {
                    lg: 'none',
                    xs: 'flex'
                  },
                  justifyContent: 'center',
                  p: 2
                }}
              >
                <RouterLink to="/">
                  <Logo
                    sx={{
                      height: 40,
                      width: 40
                    }}
                  />
                </RouterLink>
              </Box>
              <Box
                sx={{ p: 2 }}
                className="tp-customer-info__box-parent"
              >
                <Box
                  className="tp-customer-info__box"
                  sx={{
                    alignItems: 'center',
                    backgroundColor: 'background.default',
                    borderRadius: 1,
                    display: 'flex',
                    overflow: 'hidden',
                    px: 2
                  }}
                >
                  <RouterLink to="/Account">
                    <Avatar
                      src={`${process.env.REACT_APP_BASE_URL_PURE}${user.profilePicture}`}
                      sx={{
                        cursor: 'pointer',
                        height: collapsed ? 36 : 48,
                        width: collapsed ? 36 : 48
                      }}
                    />
                  </RouterLink>
                  {
                    !collapsed && (
                      <Box sx={{ ml: 0 }}>
                        <Typography
                          color="textPrimary"
                          variant="subtitle2"
                          className="tp-username"
                        >
                          {`${user.firstName} ${user.lastName}`}
                        </Typography>
                        <Typography
                          color="textSecondary"
                          variant="subtitle2"
                        >
                          {`${user.companyName || '-'}`}
                        </Typography>
                        {/* <Typography
                        color="textSecondary"
                        variant="body2"
                        className="tp-user-type-sidebar"
                      >
                        {' '}
                        <Link
                          color="primary"
                          component={RouterLink}
                          to="/change"
                          className="tp-user-type"
                        >
                          <SwapHorizontalCircleIcon />
                          {role === constants.role.buyer ? 'Müşteri' : 'Tedarikçi'}
                        </Link>
                      </Typography> */}
                      </Box>
                    )
                  }
                </Box>
              </Box>
              <Divider />
              <Box sx={{ px: 2 }}>
                {
                  mainSections.map((section) => (
                    <NavSection
                      key={section.title || 'key'}
                      pathname={location.pathname}
                      collapsed={collapsed}
                      sx={{
                        '& + &': {
                          mt: 3
                        }
                      }}
                      {...section}
                    />
                  ))
                }
              </Box>
            </Scrollbar>
          </Box>
        )
      }
    </AuthContext.Consumer>
  );
  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open
        PaperProps={{
          sx: {
            backgroundColor: 'background.paper',
            height: 'calc(100% - 64px) !important',
            top: '64px !Important',
            width: 280
          }
        }}
        variant="permanent"
        className={`tp-sidebar-up ${collapsed ? 'tp-sidebar-close' : ''}`}
      >
        {content}
      </Drawer>
    );
  }
  return (
    <Drawer
      anchor="left"
      onClose={onMobileClose}
      open={openMobile}
      PaperProps={{
        sx: {
          backgroundColor: 'background.paper',
          width: 280
        }
      }}
      variant="temporary"
      className="tp-sidebar-up"
    >
      {content}
    </Drawer>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired
};

export default DashboardSidebar;
